<template>
  <div class="min-h-screen">
    <a
      href="#main-content"
      class="skip-link"
    >
      {{ t('skip_to_content') }}
    </a>
    <!-- AB Test - Old vs New portal -->
    <input
      id="gtm_variable_ab_test_alt_vs_neu_portal"
      name="gtm_variable_ab_test_alt_vs_neu_portal"
      type="hidden"
      :value="isPortalInPortalsToBeTestedList ? 'neues_portal' : 'neues_portal_without_ab_testing'"
    >
    <LayoutHeader :wide="wide" />
    <main id="main-content">
      <slot />
    </main>
    <LazyLayoutNewsletter
      v-if="main?.element_visibility?.show_newsletter_form"
      hydrate-on-visible
    />
    <LazyLayoutFooter hydrate-on-visible />
    <DevTestOnly>
      <DevToolbar />
    </DevTestOnly>
  </div>
</template>

<script setup>
import useHost from '~/composables/useHost'
import useABTestOldVsNewPortal from '~/composables/useABTestOldVsNewPortal'

defineProps({
  wide: {
    type: Boolean,
    default: false
  }
})

const { translate: t } = useTranslations('LayoutShell')
const { main } = usePortalData()

let portalHome = usePortals().currentPortal.value?.portal?.home ?? ''
if (portalHome.endsWith('/')) {
  portalHome = portalHome.slice(0, -1)
}
const isPortalInPortalsToBeTestedList = useABTestOldVsNewPortal().isPortalInPortalsToBeTestedList(portalHome)

const route = useRoute()
const host = useHost()
useHead(() => ({
  link: [
    {
      rel: 'canonical',
      href: 'https://' + host + route.path
    }
  ]
}))
</script>

<style scoped>
@reference "~/assets/css/main.css";

.skip-link {
  @apply sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[10000] focus:bg-white focus:text-neutral-900 focus:px-4 focus:py-3 focus:rounded-lg focus:shadow-md focus:outline focus:outline-2 focus:outline-petrol-500 focus:font-semibold;
}
</style>
